export enum DataTableShellActionTypes {
  SET_CURRENT_TAB = 'DataTable-shell/SET_CURRENT_TAB',
  SET_CURRENT_PAGE = 'DataTable-shell/SET_CURRENT_PAGE',
  SET_CURRENT_CONTROLS = 'DataTable-shell/SET_CURRENT_CONTROLS',
  SET_TABLE_PAGE_INDEX = 'DataTable-shell/SET_TABLE_PAGE_INDEX',
}
